import { CartAddEvent } from '@theme/events';

/**
 * "Frequently bought together" for the PDP. The current product + the first curated
 * complementary product are rendered server-side (snippets/dgt-bundle.liquid); both
 * variant ids come from data attributes. This script only handles the add-both click.
 */

function cartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((c) => {
    if (c instanceof HTMLElement && c.dataset.sectionId) ids.add(c.dataset.sectionId);
  });
  return Array.from(ids).join(',');
}

class DgtBundle extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-bundle-add]') : null;
    if (!btn || this.#busy || btn.hasAttribute('disabled')) return;
    event.preventDefault();
    this.#addBoth(btn);
  };

  async #addBoth(btn) {
    const mainId = parseInt(this.dataset.variantId, 10);
    const recId = parseInt(this.dataset.recVariantId, 10);
    if (!mainId || !recId) return;
    this.#busy = true;
    this.classList.add('is-busy');
    const original = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [
            { id: mainId, quantity: 1 },
            { id: recId, quantity: 1 },
          ],
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (data && data.status) {
        btn.textContent = 'Unavailable';
        return;
      }
      this.dispatchEvent(
        new CartAddEvent({}, '', { source: 'dgt-bundle', sections: data.sections, didError: false })
      );
      btn.textContent = 'Added ✓';
      setTimeout(() => (btn.textContent = original), 1600);
    } catch (e) {
      console.error('[dgt-bundle] add-both failed', e);
      btn.textContent = original;
    } finally {
      this.#busy = false;
      this.classList.remove('is-busy');
    }
  }
}

if (!customElements.get('dgt-bundle')) {
  customElements.define('dgt-bundle', DgtBundle);
}
